import { Component } from '@angular/core';
import { AuthenticationService } from './../../services/authentication.service';
import { Observable } from 'rxjs';
import { Storage } from '@ionic/storage';
import { AngularDelegate, ModalController } from '@ionic/angular';
import { HttpClient, HttpErrorResponse } from '@angular/common/http';

const SCHOOLXCHANGE_INSTITUTION_ENDPOINT = 'https://api.schoolxchange.net/api/v1/mobile/schools';

@Component({
  selector: 'app-server',
  templateUrl: 'server.page.html',
  styleUrls: ['server.page.scss']

})

export class ServerPage {

  institutions: any=[];
  
  constructor(private http: HttpClient, private authService: AuthenticationService, private modalController: ModalController, private storage: Storage) {}

  ionViewWillEnter() {
    this.loadInstitutions();
  }

  loadInstitutions() {
     this.http.get(SCHOOLXCHANGE_INSTITUTION_ENDPOINT).subscribe(institutions => {
        this.showInstitutionList(institutions);
    });
  }

  showInstitutionList(institutions) {
    this.institutions = institutions;
  }

  setInstitution(institution) {
    let institution_server = {
      'institution_name': institution.institution_name,
      'host': institution.host,
      'email_autocomplete': institution.email_autocomplete,
      'oauth2_client_id': institution.oauth2_client_id,
      'oauth2_client_secret': institution.oauth2_client_secret,
    };    
    this.submit(institution_server);
  }

  submit(target_institution) {
    this.modalController.dismiss(target_institution);
  }
}
